(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-detail-tabs"] && !Shopify.designMode) return;
  try {
    class ProductDetailTabs extends HTMLElement {
    constructor() {
      super();
      this.setupTabs();
    }

    setupTabs() {
      const buttons = this.querySelectorAll('[role="tablist"] button');
      buttons.forEach((button) => {
        button.addEventListener('click', (e) => this.handleTabClick(e));
      });
    }

    handleTabClick(event) {
      const button = event.currentTarget;
      const tabIndex = button.dataset.tabIndex;
      this.activateTab(tabIndex);
    }

    activateTab(tabIndex) {
      // Deactivate all tabs
      const buttons = this.querySelectorAll('[role="tablist"] button');
      buttons.forEach((btn) => {
        btn.setAttribute('aria-selected', 'false');
      });

      // Hide all panels
      const panels = this.querySelectorAll('[role="tabpanel"]');
      panels.forEach((panel) => {
        panel.setAttribute('hidden', '');
      });

      // Activate selected tab
      const selectedButton = this.querySelector(
        `[role="tablist"] button[data-tab-index="${tabIndex}"]`
      );
      if (selectedButton) {
        selectedButton.setAttribute('aria-selected', 'true');
      }

      // Show selected panel
      const selectedPanel = this.querySelector(`#panel-${tabIndex}`);
      if (selectedPanel) {
        selectedPanel.removeAttribute('hidden');
      }
    }
  }

  customElements.define('product-detail-tabs', ProductDetailTabs);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-tabs-backup"] && !Shopify.designMode) return;
  try {
    class ProductDetailTabs extends HTMLElement {
    constructor() {
      super();
      this.setupTabs();
      this.distributeBlocks();
    }

    setupTabs() {
      const buttons = this.querySelectorAll('[role="tablist"] button');
      buttons.forEach((button) => {
        button.addEventListener('click', (e) => this.handleTabClick(e));
      });
    }

    distributeBlocks() {
      const container = this.querySelector('.product-detail-tabs__blocks-container');
      if (!container) return;

      const panels = this.querySelectorAll('[role="tabpanel"]');
      const blocks = Array.from(container.querySelectorAll('[data-block-id]'));
      
      blocks.forEach((block, index) => {
        const tabNumber = Math.floor(index / 3) + 1;
        if (tabNumber <= panels.length) {
          const panel = this.querySelector(`[data-tab-index="${tabNumber}"]`);
          if (panel) {
            panel.appendChild(block);
          }
        }
      });

      // Remove empty container
      if (container.children.length === 0) {
        container.remove();
      }
    }

    handleTabClick(event) {
      const button = event.currentTarget;
      const tabIndex = button.dataset.tabIndex;
      this.activateTab(tabIndex);
    }

    activateTab(tabIndex) {
      // Deactivate all tabs
      const buttons = this.querySelectorAll('[role="tablist"] button');
      buttons.forEach((btn) => {
        btn.setAttribute('aria-selected', 'false');
      });

      // Hide all panels
      const panels = this.querySelectorAll('[role="tabpanel"]');
      panels.forEach((panel) => {
        panel.setAttribute('hidden', '');
      });

      // Activate selected tab
      const selectedButton = this.querySelector(
        `[role="tablist"] button[data-tab-index="${tabIndex}"]`
      );
      if (selectedButton) {
        selectedButton.setAttribute('aria-selected', 'true');
      }

      // Show selected panel
      const selectedPanel = this.querySelector(`[data-tab-index="${tabIndex}"]`);
      if (selectedPanel) {
        selectedPanel.removeAttribute('hidden');
      }
    }
  }

  customElements.define('product-detail-tabs', ProductDetailTabs);
  } catch(e) { console.error(e); }
})();

})();
